import { VibesitesImage } from '@vibesites/ui-primitives';

const LOGO_COLOR =
  'https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp';

const LOGO_SIZES = '(min-width: 1280px) 284px, (min-width: 1024px) 249px, 120px';

interface NavLogoProps {
  url: string;
  alt: string;
  docked: boolean;
}

export function NavLogo({ url, alt, docked }: NavLogoProps) {
  return (
    <span className="relative block">
      <VibesitesImage
        url={url}
        alt={alt}
        width={284}
        height={128}
        objectFit="contain"
        priority
        sizes={LOGO_SIZES}
        className={`block w-auto transition-[height,opacity] duration-500 ease-out ${
          docked ? 'h-10 opacity-0 lg:h-20' : 'h-10 opacity-100 lg:h-28 xl:h-32'
        }`}
      />
      <span
        aria-hidden
        className={`pointer-events-none absolute left-0 top-1/2 -translate-y-1/2 transition-opacity lg:right-0 duration-500 ease-out ${
          docked ? 'opacity-100' : 'opacity-0'
        }`}
      >
        <VibesitesImage
          url={LOGO_COLOR}
          alt=""
          width={284}
          height={128}
          objectFit="contain"
          sizes={LOGO_SIZES}
          className="block h-auto w-[120px] max-w-none lg:w-full lg:max-w-full"
        />
      </span>
    </span>
  );
}

export default NavLogo;
